/** 班线客运 线路排班 */
<template>
  <div id="lines">
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
                  addText="创建线路" @addFn="addClick" addTexts="配置分类标签" @addFns="settinLabel" @resetFn="resetFn">

      <template slot="deep-search-append">

<!--        <div class="grouping-field-item" style="-ms-grid-column: 1;min-width:274px">-->
<!--          <div class="grouping-field-value">-->
<!--            <el-select v-model="customOptions.params.startStationName" placeholder="搜索出发地" @change="queryFn" remote-->
<!--                       filterable clearable :remote-method="remoteMethodStartStationName"-->
<!--                       :loading="remoteMethodLoading">-->
<!--              <el-option v-for="(item, index) in startStationNameOptions" :key="index" :label="item.label"-->
<!--                         :value="item.name">-->
<!--                <span>{{ item.nameBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.nameMatching }}</span>-->
<!--                <span>{{ item.nameAfter }}</span>-->
<!--                ㅤ-->
<!--                <span>{{ item.codeBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.codeMatching }}</span>-->
<!--                <span>{{ item.codeAfter }}</span>-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="grouping-field-item" style="-ms-grid-column: 1;min-width:274px">-->
<!--          <div class="grouping-field-value">-->
<!--            <el-select v-model="customOptions.params.endStationName" placeholder="搜索目的地" @change="queryFn" remote-->
<!--                       filterable clearable :remote-method="remoteMethodendEndStationName"-->
<!--                       :loading="remoteMethodLoading">-->
<!--              <el-option v-for="(item, index) in endStationNameOptions" :key="index" :label="item.label"-->
<!--                         :value="item.name">-->
<!--                <span>{{ item.nameBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.nameMatching }}</span>-->
<!--                <span>{{ item.nameAfter }}</span>-->
<!--                ㅤ-->
<!--                <span>{{ item.codeBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.codeMatching }}</span>-->
<!--                <span>{{ item.codeAfter }}</span>-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="grouping-field-item" style="-ms-grid-column: 1;min-width:274px">-->
<!--          <div class="grouping-field-value">-->
<!--            <el-select v-model="customOptions.params.startStationCode" placeholder="搜索出发地速记码" @change="queryFn"-->
<!--                       remote-->
<!--                       filterable clearable :remote-method="remoteMethodStartStationCode"-->
<!--                       :loading="remoteMethodLoading">-->
<!--              <el-option v-for="(item, index) in startStationCodeOptions" :key="index" :label="item.label"-->
<!--                         :value="item.code">-->
<!--                <span>{{ item.nameBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.nameMatching }}</span>-->
<!--                <span>{{ item.nameAfter }}</span>-->
<!--                ㅤ-->
<!--                <span>{{ item.codeBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.codeMatching }}</span>-->
<!--                <span>{{ item.codeAfter }}</span>-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="grouping-field-item" style="-ms-grid-column: 1;min-width:274px">-->
<!--          <div class="grouping-field-value">-->
<!--            <el-select v-model="customOptions.params.endStationCode" placeholder="搜索目的地速记码" @change="queryFn"-->
<!--                       remote-->
<!--                       filterable clearable :remote-method="remoteMethodendEndStationCode"-->
<!--                       :loading="remoteMethodLoading">-->
<!--              <el-option v-for="(item, index) in endStationCodeOptions" :key="index" :label="item.label"-->
<!--                         :value="item.code">-->
<!--                <span>{{ item.nameBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.nameMatching }}</span>-->
<!--                <span>{{ item.nameAfter }}</span>-->
<!--                ㅤ-->
<!--                <span>{{ item.codeBefore }}</span>-->
<!--                <span style="color: #0066FF">{{ item.codeMatching }}</span>-->
<!--                <span>{{ item.codeAfter }}</span>-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </div>-->

      </template>


      <template slot="table-operation">
        <el-table-column label="操作" width="200" fixed="right" v-slot="{ row }">
          <el-button type="text" @click="schedulingClick(row)">排班</el-button>
          <el-button type="text" @click="editClick(row)">查看</el-button>
          <el-dropdown @command="handleCommand($event, row)">
            <span class="el-dropdown-link" style="font-size:12px;color:#409EFF;cursor:pointer">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="ticketRestrictionsConfig">购票限制</el-dropdown-item>
              <el-dropdown-item command="ticketRestrictionsConfig2">售票限制</el-dropdown-item>
              <el-dropdown-item command="removeClick" style="color:#F56C6C">删除线路</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'fee'">
          <span class="util-money">￥{{ row.fee || 0 }} {{ row.isSameRailFee == 1 ? '' : '起' }}</span>
        </template>
        <template v-else-if="item.prop === 'startStationName'">
          <div>{{ row.startStationName }}</div>
          <span class="tips">{{ row.startStationCode }}</span>
        </template>
        <template v-else-if="item.prop === 'endStationName'">
          <div>{{ row.endStationName }}</div>
          <span class="tips">{{ row.endStationCode }}</span>
        </template>
        <template v-else-if="item.prop === 'dutyVehicle'">
          <el-tooltip v-if="row.dutyVehicle">
            <p slot="content">{{ row.dutyVehicle }}</p>
            <p style="max-height:46px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;white-space:normal;-webkit-line-clamp:2;-webkit-box-orient:vertical;">
              {{ row.dutyVehicle }}
            </p>
          </el-tooltip>
          <span v-else style="color:#999">无车辆</span>
        </template>
        <template v-else-if="item.prop === 'commissionConfigName'">
          <span :style="{ color: row.commissionConfigName ? '#0099FF' : '#999' }">
            {{ row.commissionConfigName || '无提成规则' }}
          </span>
        </template>
        <template v-else-if="item.prop === 'ticketRestrictions'">
          <span class="tips">{{ row.ticketRestrictions == 1 ? '非实名' : '实名' }}</span>
        </template>
        <template v-else-if="item.prop === 'stationRegister'">
          <span>{{ row.stationRegister == 1 ? '报班后才能售票' : '不报班也能售票' }}</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <!-- 创建线路 -->
    <el-dialog :visible.sync="visible" :title="lineId ? '编辑线路' : '创建线路'" width="750px" :before-close="closeFn"
               :close-on-click-modal="false">
      <lineForm :visible="visible" :lineId="lineId" @closeFn="closeFn"/>
    </el-dialog>

    <!--购票限制弹框-->
    <el-dialog title="请选择购票限制" :visible.sync="ticketRestrictionsConfigVisible" width="700px"
               :close-on-click-modal="false">
      <el-radio-group v-model="ticketRestrictionsConfigRow.ticketRestrictions">
        <div class="flex">
          <el-radio :label="1">非实名购票</el-radio>
        </div>
        <div class="tips" style="margin:10px 0 30px;font-size:14px">乘客只提供电话号码即可购票</div>
        <div class="flex">
          <el-radio :label="2">实名购票</el-radio>
          <el-checkbox label="启用小程序下单实名校验" v-model="ticketRestrictionsConfigRow.customerRealName"
                       :disabled="ticketRestrictionsConfigRow.ticketRestrictions != 2"></el-checkbox>
          <el-checkbox label="启用平台下单实名校验" v-model="ticketRestrictionsConfigRow.systemRealName"
                       :disabled="ticketRestrictionsConfigRow.ticketRestrictions != 2"></el-checkbox>
        </div>
        <div class="tips" style="margin-top:10px;line-height: 20px;font-size:14px">
          * 须提供乘客真实姓名、身份证号码、联系电话才能购票
          <br/>
          * 如开启实名校验，则按1人/1次/{{verifyIdCardPrice}}元的收费规则，请确保AI识别余额充足
          <br/>
          * 如关闭实名校验，则只验证身份证号码格式是否正确，不会校验乘客姓名+身份证号码是否匹配
        </div>
      </el-radio-group>

      <div slot="footer">
        <el-button @click="ticketRestrictionsConfigVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTicketRestrictions">保存</el-button>
      </div>
    </el-dialog>

    <!--售票限制弹框-->
    <el-dialog title="请选择售票限制" :visible.sync="ticketRestrictionsConfigVisible2" width="550px"
               :close-on-click-modal="false">

      <div>
        <el-radio-group v-model="ticketRestrictionsConfigRow2.stationRegister">
          <el-radio :label="1" :value="1">报班后才能售票</el-radio>
          <el-radio :label="2" :value="2">不报班也能售票</el-radio>
        </el-radio-group>


        <div class="util-remark" style="margin-top: 20px">
          注意！如已排班次，修改售票限制将产生影响：<br/>
          1.修改为“报班后才能售票”，现未报班但正售的班次将改为“停售”状态；<br/>
          2.修改为“不报班也能售票”，现未报班但停售的班次将改为“正售”状态。<br/>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="ticketRestrictionsConfigVisible2 = false">取消</el-button>
        <el-button type="primary" @click="saveTicketRestrictions2">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog
        :title="lineId? '编辑线路':'创建线路'"
        :before-close="handClose"
        :visible.sync="visibleNewLine"
        destroy-on-close
        :close-on-click-modal="false"
        width="700px">
      <lineNewForm v-if="visibleNewLine" :lineId="lineId" @handClose="handClose" @handSuccess="handSuccess"/>
    </el-dialog>

    <el-dialog title="配置分类标签" :visible.sync="labelVisble" width="25%" @close="labelVisble = false">
      <div style="margin-bottom: 10px;color: #999;">您可以创建自定义标签，用于线路分类</div>
      <el-table max-height="500px" border empty-text="暂无数据" :data="labelList">
        <el-table-column label="标签名称" prop="name">
          <template v-slot="scope">
            <div v-if="scope.row.edit">
              <el-input v-model="scope.row.name" placeholder="请输入标签名称" maxlength="8"></el-input>
            </div>
            <div v-else>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template v-slot="scope">
            <el-button v-if="scope.row.edit" @click="addLabel(scope.row)" type="text" size="small">保存</el-button>
            <el-button v-if="!scope.row.edit" type="text" size="small" @click="deleteLabel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-show="!(labelList.slice(-1)[0] && labelList.slice(-1)[0].edit)"
                 style="border: 1px #dcdfe6 dashed;margin-top: 20px;padding: 10px;width: 100%;"
                 @click="addLabelClick">添加标签
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "lines",
  components: {
    lineForm: () => import("./components/lineForm"),
    lineNewForm: () => import("./components/lineNewForm"),
  },
  data() {
    return {
      labelVisble: false,
      labelList: [],
      // 配置项
      customOptions: {

        // 请求的列表url
        url: "/api/v1/manage/line/station/scheduling",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          startStationName: null,
          endStationName: null,
          startStationCode: null,
          endStationCode: null,
        },
        search: [
          {
            type: "select", field: "lineId", name: "搜索线路", value: null,
            filterable:true,
            props: {label: 'stationName', value: 'id',},
            option: []
          },
          { type: "input", field: "startStationName", name: "出发地", value: "" },
          { type: "input", field: "endStationName", name: "目的地", value: "" },
          {
            type: "select",
            field: "ticketRestrictions",
            name: "购票限制",
            value: "",
            option: [
              {label: '实名', value: "2"},
              {label: '非实名', value: "1"},
            ],
            disabled: false,
          },
          {
            type: "select",
            field: "stationRegister",
            name: "售票限制",
            value: "",
            option: [
              {label: '报班后才能售票', value: "1"},
              {label: '不报班也能售票', value: "2"},
            ],
            disabled: false,
          }
        ],
      },
      columns: [
        {prop: "labelName", label: "分类标签"},
        {prop: "startStationName", label: "出发地"},
        {prop: "endStationName", label: "目的地"},
        {prop: "schedulingDate", label: "已排班次"},
        {prop: "dutyVehicle", label: "值班车辆", minWidth: 160},
        {prop: "fee", label: "票价"},
        {prop: "commissionConfigName", label: "提成规则", minWidth: 120},
        {prop: "ticketRestrictions", label: "购票限制"},
        {prop: "stationRegister", label: "报班售票"}
      ],
      startStationNameOptions: [],
      endStationNameOptions: [],
      startStationCodeOptions: [],
      endStationCodeOptions: [],
      remoteMethodLoading: false,

      visible: false,
      visibleNewLine: false,
      form: {},
      lineId: null,

      ticketRestrictionsConfigVisible: false,
      ticketRestrictionsConfigRow: {},

      ticketRestrictionsConfigVisible2: false,
      ticketRestrictionsConfigRow2: {},
      verifyIdCardPrice: 0


    };
  },
  methods: {
    /* 删除标签 */
    async deleteLabel(item) {
      let url = "/api/v1/manage/lineLabel";
      let data = await this.$axios.delete(url, {id: item.id});
      if (data && data.code === 1) {
        this.$message.info("已删除");
        this.getlabelList();
        this.$refs.customTable.listFn();
      }
    },
    /* 添加标签 */
    async addLabel(item) {
      if (!item.name) {
        this.$message.warning("请输入标签名称");
        return;
      }
      let url = "/api/v1/manage/lineLabel/save";
      let data = await this.$axios.post(url, item);
      if (data && data.code === 1) {
        this.$message.info("已添加");
        this.getlabelList();
      }
    },
    addLabelClick() {
      if (this.labelList.length == 30) {
        this.$message.info("最多添加30个标签");
        return;
      }
      this.labelList.push({name: null, edit: true});
    },
    /* 分类标签列表 */
    async getlabelList() {
      let url = "/api/v1/manage/lineLabel/labelList";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.labelList = [];
          this.customOptions.search[0].option = [
            {
              value: null,
              label: "未配置标签",
            },
          ];
          this.customOptions.search[0].disabled = true;
        } else {
          this.labelList = data.data;
          this.customOptions.search[0].option = Array.from(
              data.data,
              (val) => ({label: val.name, value: val.id})
          );
          this.customOptions.search[0].disabled = false;
        }
        this.tableShow = true;
        this.$forceUpdate();
      }
    },
    /* 配置分类标签 */
    settinLabel() {
      this.getlabelList();
      this.labelVisble = true;
    },
    async getVerifyIdCardPrice () {
      let url = "api/v1/manage/ai/platform/config"
      const {code, data} = await this.$axios.get(url);
      if(code == 1) {
        this.verifyIdCardPrice = data.verifyIdCard || 0
      }
    },
    handClose() {
      this.lineId = ''
      this.visibleNewLine = false
    },
    handSuccess() {
      this.handClose()
      this.$refs.customTable.listFn();
    },
    /* 重置 */
    resetFn() {
      console.log('重置');
      this.customOptions.params.startStationName = null;
      this.customOptions.params.endStationName = null;
      this.customOptions.params.startStationCode = null;
      this.customOptions.params.endStationCode = null;
    },
    /* 获取出发地名称 */
    async remoteMethodStartStationName(query) {
      if (query !== '') {
        this.remoteMethodLoading = true;
        let url = "/api/v1/manage/line/station/scheduling/query";
        let params = {startStationName: query}
        let data = await this.$axios.get(url, params);
        if (data && data.code == 1) {
          this.startStationNameOptions = data.data.map(item => {
            let length = query.length;
            let name = item.startStationName;
            let code = item.startStationCode || '';
            let nameIndex = name.indexOf(query);
            let codeIndex = code ? code.indexOf(query) : -1;
            return {
              name: item.startStationName,
              label: item.startStationName + ' ' + code,
              nameBefore: nameIndex > -1 ? name.slice(0, nameIndex) : name,
              nameMatching: nameIndex > -1 ? name.slice(nameIndex, nameIndex + length) : null,
              nameAfter: nameIndex > -1 ? name.slice(nameIndex + length) : null,
              codeBefore: codeIndex > -1 ? code.slice(0, codeIndex) : code,
              codeMatching: codeIndex > -1 ? code.slice(codeIndex, codeIndex + length) : null,
              codeAfter: codeIndex > -1 ? code.slice(codeIndex + length) : null
            }
          });
          this.remoteMethodLoading = false;
        }
      } else {
        this.startStationNameOptions = [];
      }
    },
    /* 获取目的地名称 */
    async remoteMethodendEndStationName(query) {
      if (query !== '') {
        this.remoteMethodLoading = true;
        let url = "/api/v1/manage/line/station/scheduling/query";
        let params = {endStationName: query}
        let data = await this.$axios.get(url, params);
        if (data && data.code == 1) {
          this.endStationNameOptions = data.data.map(item => {
            let length = query.length;
            let name = item.endStationName;
            let code = item.endStationCode || '';
            let nameIndex = name.indexOf(query);
            let codeIndex = code ? code.indexOf(query) : -1;
            return {
              name: item.endStationName,
              label: item.endStationName + ' ' + code,
              nameBefore: nameIndex > -1 ? name.slice(0, nameIndex) : name,
              nameMatching: nameIndex > -1 ? name.slice(nameIndex, nameIndex + length) : null,
              nameAfter: nameIndex > -1 ? name.slice(nameIndex + length) : null,
              codeBefore: codeIndex > -1 ? code.slice(0, codeIndex) : code,
              codeMatching: codeIndex > -1 ? code.slice(codeIndex, codeIndex + length) : null,
              codeAfter: codeIndex > -1 ? code.slice(codeIndex + length) : null
            }
          });
          this.remoteMethodLoading = false;
        }
      } else {
        this.endStationNameOptions = [];
      }
    },
    /* 获取出发地速记码 */
    async remoteMethodStartStationCode(query) {
      if (query !== '') {
        this.remoteMethodLoading = true;
        let url = "/api/v1/manage/line/station/scheduling/query";
        let params = {startStationCode: query}
        let data = await this.$axios.get(url, params);
        if (data && data.code == 1) {
          this.startStationCodeOptions = data.data.map(item => {
            let length = query.length;
            let name = item.startStationName;
            let code = item.startStationCode;
            let nameIndex = name.indexOf(query);
            let codeIndex = code.indexOf(query);
            return {
              code: item.startStationCode,
              label: item.startStationName + ' ' + code,
              nameBefore: nameIndex > -1 ? name.slice(0, nameIndex) : name,
              nameMatching: nameIndex > -1 ? name.slice(nameIndex, nameIndex + length) : null,
              nameAfter: nameIndex > -1 ? name.slice(nameIndex + length) : null,
              codeBefore: codeIndex > -1 ? code.slice(0, codeIndex) : code,
              codeMatching: codeIndex > -1 ? code.slice(codeIndex, codeIndex + length) : null,
              codeAfter: codeIndex > -1 ? code.slice(codeIndex + length) : null
            }
          });
          this.remoteMethodLoading = false;
        }
      } else {
        this.startStationCodeOptions = [];
      }
    },
    /* 获取目的地速记码 */
    async remoteMethodendEndStationCode(query) {
      if (query !== '') {
        this.remoteMethodLoading = true;
        let url = "/api/v1/manage/line/station/scheduling/query";
        let params = {endStationCode: query}
        let data = await this.$axios.get(url, params);
        if (data && data.code == 1) {
          this.endStationCodeOptions = data.data.map(item => {
            let length = query.length;
            let name = item.endStationName;
            let code = item.endStationCode;
            let nameIndex = name.indexOf(query);
            let codeIndex = code.indexOf(query);
            return {
              code: item.endStationCode,
              label: item.endStationName + ' ' + code,
              nameBefore: nameIndex > -1 ? name.slice(0, nameIndex) : name,
              nameMatching: nameIndex > -1 ? name.slice(nameIndex, nameIndex + length) : null,
              nameAfter: nameIndex > -1 ? name.slice(nameIndex + length) : null,
              codeBefore: codeIndex > -1 ? code.slice(0, codeIndex) : code,
              codeMatching: codeIndex > -1 ? code.slice(codeIndex, codeIndex + length) : null,
              codeAfter: codeIndex > -1 ? code.slice(codeIndex + length) : null
            }
          });
          this.remoteMethodLoading = false;
        }
      } else {
        this.endStationCodeOptions = [];
      }
    },

    queryFn() {
      this.startStationNameOptions = [];
      this.endStationNameOptions = [];
      this.startStationCodeOptions = [];
      this.endStationCodeOptions = [];
      this.$refs.customTable.listFn();
    },

    /* 点击下拉按钮 */
    handleCommand(e, row) {
      this[e](row);
    },

    /* 编辑购票限制 */
    async ticketRestrictionsConfig(row) {
      this.ticketRestrictionsConfigRow = {
        id: row.id,
        ticketRestrictions: row.ticketRestrictions,
        customerRealName: row.customerRealName == 1 ? true : false,
        systemRealName: row.systemRealName == 1 ? true : false
      };
      this.getVerifyIdCardPrice()
      this.ticketRestrictionsConfigVisible = true;
    },

    /* 编辑售票限制 */
    ticketRestrictionsConfig2(row) {
      this.ticketRestrictionsConfigRow2 = {
        id: row.id,
        stationRegister: row.stationRegister
      };
      this.ticketRestrictionsConfigVisible2 = true;
    },

    /* 保存线路购票限制 */
    async saveTicketRestrictions() {
      let url = "/api/v1/manage/line/ticketRestrictions";
      let params = {
        id: this.ticketRestrictionsConfigRow.id,
        ticketRestrictions: this.ticketRestrictionsConfigRow.ticketRestrictions,
        customerRealName: this.ticketRestrictionsConfigRow.customerRealName ? 1 : 2,
        systemRealName: this.ticketRestrictionsConfigRow.systemRealName ? 1 : 2,
      }
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.ticketRestrictionsConfigVisible = false;
        this.$refs.customTable.listFn();
        this.$message.success('已修改购票限制')
      }
    },

    /* 保存线路售票限制 */
    async saveTicketRestrictions2() {
      let url = "/api/v1/manage/line/stationRegister";
      let params = {
        id: this.ticketRestrictionsConfigRow2.id,
        stationRegister: this.ticketRestrictionsConfigRow2.stationRegister,
      }
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.ticketRestrictionsConfigVisible2 = false;
        this.$refs.customTable.listFn();
        this.$message.success('已修改售票限制');
      }
    },

    /* 创建 */
    addClick() {
      if (this.mixinUserInfo.platformType == 2) {
        this.visibleNewLine = true;
      } else {
        this.visible = true;
      }

    },

    /* 编辑 */
    async editClick(row) {
      if (this.mixinUserInfo.platformType == 2) {
        this.lineId = row.id;
        this.visibleNewLine = true;
      } else {
        this.lineId = row.id;
        this.visible = true;
      }

    },

    async isBinding(row) {
      let url = "/api/v1/manage/line/binding";
      let params = {id: row.id};
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        return data.data;
      }
    },

    /* 删除 */
    async removeClick(row) {
      this.$confirm('确定删除该班线吗', "删除提示").then(async () => {
        let url = "/api/v1/manage/line";
        let params = {id: row.id,};
        let data = await this.$axios.delete(url, params);
        if (data && data.code === 1) {
          this.$message.success("删除成功");
          this.$refs.customTable.listFn();
        }
      });
    },

    /* 关闭 */
    closeFn(event) {
      this.visible = false;
      this.lineId = null;
      if (!event) {
        this.$refs.customTable.listFn();
      }
    },

    /* 排班 */
    schedulingClick(row) {
      this.$router.push({path: "/schedulingTimeForm", query: {id: row.id}});
    }
  },
};
</script>

<style lang="less">
#lines {
  .flex {
    .el-radio {
      display: flex;
      align-items: center;
    }

    .el-radio__label {
      display: inline;
      font-weight: bold;
    }
  }
}
</style>
